export const periodsStoreKey = 'periods';
